import vueTypes from 'vue-types'
import { vacancy, css, i18n, view } from './job-list'

export default {
  group: vueTypes.shape({
    id: vueTypes.any,
    name: vueTypes.string,
    position: vueTypes.number,
    vacancies: vueTypes.arrayOf(vacancy)
  }).loose,
  options: vueTypes.shape({
    css,
    i18n,
    view
  })
}
